// Funções para definir e pegar cookies
function setCookie(cname, cvalue, exminutes) {
  const d = new Date();
  d.setTime(d.getTime() + (exminutes * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return null;
}

// Inicialização do countdown
const countdownContainer = document.querySelector('.love__chocolate__countdown__container');
const daysLeft = parseInt(countdownContainer.getAttribute('data-days'), 10) || 0;
const hoursLeft = parseInt(countdownContainer.getAttribute('data-hours'), 10) || 0;
const minutesLeft = parseInt(countdownContainer.getAttribute('data-min'), 10) || 0;
const secondsLeft = parseInt(countdownContainer.getAttribute('data-seg'), 10) || 0;

// Função para obter data final do contador
function getCountdownDate() {
  const now = new Date().getTime();
  return now +
    daysLeft * 24 * 60 * 60 * 1000 +
    hoursLeft * 60 * 60 * 1000 +
    minutesLeft * 60 * 1000 +
    secondsLeft * 1000;
}

// Recupera data do cookie ou gera nova se não existir
let countdownDate = parseInt(getCookie('countdownDate'), 10);

if (!countdownDate || isNaN(countdownDate)) {
  countdownDate = getCountdownDate();
  setCookie('countdownDate', countdownDate, 30); // 30 minutos
}

function updateCountdown() {
  const now = new Date().getTime();
  let distance = countdownDate - now;

  if (distance < 0) {
    countdownDate = getCountdownDate();
    setCookie('countdownDate', countdownDate, 30); // Atualiza o cookie ao reiniciar
    distance = countdownDate - now;
  }

  const days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
  const seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');

   const textoContagem = `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;

  document.querySelectorAll(".love_chocolate__countdown__block__timer").forEach(el => {
    el.innerHTML = `
      <div style="display:flex;gap:8px;text-align:center;justify-content:center;align-items: center">
        <div style="line-height:1.1;">
          <div style="font-size:1.3em;font-weight:bold;">${days}</div>
          <div style="font-size:0.5em; font-weight: normal;">Dia(s)</div>
        </div>
        <div style="font-size:1.3em;">:</div>
        <div style="line-height:1.1;">
          <div style="font-size:1.3em;font-weight:bold;">${hours}</div>
          <div style="font-size:0.5em; font-weight: normal;">Hora(s)</div>
        </div>
        <div style="font-size:1.3em;">:</div>
        <div style="line-height:1.1;">
          <div style="font-size:1.3em;font-weight:bold;">${minutes}</div>
          <div style="font-size:0.5em; font-weight: normal;">Min(s)</div>
        </div>
        <div style="font-size:1.3em;">:</div>
        <div style="line-height:1.1;">
          <div style="font-size:1.3em;font-weight:bold;">${seconds}</div>
          <div style="font-size:0.5em; font-weight: normal;">Seg(s)</div>
        </div>
      </div>
    `;
  });

    document.querySelectorAll(".countdown-text").forEach(el => {
      el.textContent = textoContagem;
  });
}



// Inicializa o contador imediatamente
updateCountdown();

// Atualiza a cada segundo
const interval = setInterval(updateCountdown, 1000);
